module.exports = __webpack_public_path__ + "static/media/14.00d5d9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/14.png
// module id = 866
// module chunks = 0